interface Props {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  testId: string;
}

const HullCleaningFilterSelect = ({ label, value, options, onChange, testId }: Props) => (
  <label className="block min-w-0">
    <span className="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-300">{label}</span>
    <select value={value} onChange={(event) => onChange(event.target.value)} data-test={testId} className="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-xs text-gray-700 outline-none focus:border-green focus:ring-1 focus:ring-green dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200">
      <option value="">All</option>
      {options.map((option) => <option key={option} value={option}>{option}</option>)}
    </select>
  </label>
);

export default HullCleaningFilterSelect;
